import { $substr } from "./substr";
const $substrCP = (obj, expr, options) => {
  return $substr(obj, expr, options);
};
export {
  $substrCP
};
